<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import GetDeliveryButton from "./GetDeliveryButton.svelte";
  import AutoplayVideo from "./AutoplayVideo.svelte";

  // Get the block data
  export let blok;
</script>

<section class="video-cta-section mx-auto" use:storyblokEditable={blok}>
  <div class="text-wrapper">
    <h1 class="main-heading">{blok.heading}</h1>
    <h2 class="main-subheading">{blok.subheading}</h2>
    <GetDeliveryButton {blok} />
  </div>

  <div class="video-wrapper">
    <AutoplayVideo
      videoMobile={blok.videoMobile}
      videoDesktop={blok.videoDesktop}
      videoPlaceholderMobile={blok.videoPlaceholderMobile}
      videoPlaceholderDesktop={blok.videoPlaceholderDesktop}
    />
  </div>
</section>

<style lang="postcss">
  .video-cta-section {
    position: relative;
    margin: 3rem 20px;
    background: #0f8dc1;
    border-radius: 10px;
    overflow: hidden;

    @screen lg {
      margin: 8rem auto 4rem auto;
      padding-left: 2rem;
      padding-right: 2rem;
      max-width: 1500px;
      background: none;
    }
  }

  .text-wrapper {
    position: absolute;
    bottom: 2rem;
    left: 50%;
    width: calc(100% - 50px);
    transform: translateX(-50%);
    text-align: center;
    z-index: 10;

    @screen md {
      width: 300px;
      top: 50%;
      bottom: auto;
      left: 2rem;
      transform: translateY(-50%);
      text-align: left;
    }

    @screen lg {
      width: 360px;
      left: 200px;
    }
  }

  .video-cta-section :global(.get-delivery-button-wrapper) {
    margin-left: 0;
    margin-right: 0;
  }

  .video-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 5;

    @screen lg {
      position: relative;
    }
  }

  .video-cta-section :global(.autoplay-video-wrapper) {
    @screen lg {
      border-radius: 10px;
      overflow: hidden;
    }
  }

  .main-heading {
    font-size: 24px;
    font-family: var(--font-primary);
    font-weight: var(--font-weight-medium);
    line-height: 1.6;
    color: #fff;

    @screen lg {
      font-size: 28px;
    }
  }

  .main-subheading {
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-size: 16px;
    font-weight: 300;
    color: #fff;

    @screen lg {
      font-size: 18px;
    }
  }
</style>
